export const calculateVatHeight = (vatFormula: string, vatSize: string): number | undefined => {
	switch (vatFormula) {
		case 'Butterfly': {
			switch (vatSize) {
				case '1050':
					return 610;
				case '1700':
					return 915;
				case '2250':
					return 1175;
				case '2700':
					return 1420;
				case '2700Cummings':
					return 1420;
				case '3400':
					return 1465;
				case '3400Winiata':
					return 1465;
				case '3400KMOrganics':
					return 1465;
				case '3700':
					return 1465;
				case '3700DargavilleOrganics':
					return 1465;
				case '4100':
					return 1595;
				case '4500':
					return 1760;
				case '4500TawaRidge':
					return 1760;
				case '5700':
					return 2170;
				case '6800':
					return 2565;
				case '9100':
					return 3395;
			}
		}
		case 'Crown': {
			switch (vatSize) {
				case '22000':
					return 0;
			}
		}
		case 'Longveld': {
			switch (vatSize) {
				case '5400':
					return 1500;
				case '7500':
					return 2000;
				case '9400':
					return 2440;
				case '11400':
					return 2100;
				case '21000':
					return 3520;
				case '29000':
					return 4628;
			}
		}
		case 'Spherical': {
			switch (vatSize) {
				case '10000':
					return 2673;
				case '14000':
					return 2990;
				case '24500':
					return 3600;
				case '31000':
					return 3900;
			}
		}
		case 'FonterraVatII': {
			switch (vatSize) {
				case '2000':
					return 2022;
				case '2300':
					return 1099;
				case '3400':
					return 1260;
				case '4100':
					return 1493;
				case '4500':
					return 1034;
				case '5700':
					return 1338;
				case '6800':
					return 1607;
				case '7800':
					return 1817;
				case '9100':
					return 2251;
				case '11000':
					return 2562;
				case '11500W':
					return 1794;
				case '12000':
					return 2837;
				case '14000':
					return 3312;
				case '14000W':
					return 2232;
				case '15000':
					return 3650;
				case '16000':
					return 3750;
				case '16000W':
					return 2518;
				case '18000':
					return 4360;
				case '18000W':
					return 2930;
				case '21500W':
					return 3300;
				case '24500W':
					return 3738;
				case '26500W':
					return 4043;
				case '30000W':
					return 4823;
			}
		}
		default: {
			return undefined;
		}
	}
};
